const purchaseRouter = {
  path: '/purchase',
  component: () => import('@/layout'),
  redirect: '/purchase/release',
  children: [
    {
      path: 'release',
      name: 'PurchaseRelease',
      meta: { title: '找获需求' },
      component: () =>
        import(/* webpackChunkName: "purchase" */ '@/pages/member/purchase/pages/release')
    },
    {
      path: 'success',
      name: 'PurchaseSuccess',
      meta: { title: '找获需求成功' },
      component: () =>
        import(/* webpackChunkName: "purchase" */ '@/pages/member/purchase/pages/success')
    }
  ]
}

export default purchaseRouter
